<template>
    <div class="ui-recent" :class="version == 'horiz'?'h-17':'h-19'">
        <div id="ui-server" v-if="serviceNumStatus"></div> 
    </div>
</template>

<script>
import fitChartSize from "@/common/js/echartFontSize.js"
import NoneData from '@/components/NoneData.vue'
export default { 
    props:{ 
        lineList: {
            type: Array,
            default: []
        },
        serviceNumStatus:{
            type:Boolean,
            default:false
        },
        version:{
            type:String,
        },
    },
    components:{
        NoneData
    },
    watch:{
        lineList(val){ 
            this.proName = [];
            this.serviceNum = []; 
            val.map(item=>{
                this.proName.push(item.serviceName);
                this.serviceNum.push(item.serviceNum); 
            }) 
            setTimeout(()=>{
                this.initServiceEcharts();
            },500) 
        } 
    },
    data () {
      return { 
          proName:[],
          serviceNum:[],//饮水人数 
          timer:null
      }
    }, 
    methods: {
        // 项目饮水人数与用水趋势
        initServiceEcharts(){
            if(this.serviceNumStatus){
                this.$nextTick(()=>{
                    let that = this;
                    let myChart = echarts.init(document.getElementById('ui-server'), null, { renderer: 'svg' }) 
                    let option;
                    let proName = JSON.parse(JSON.stringify(that.proName));
                    let serviceNum = JSON.parse(JSON.stringify(that.serviceNum)); 
                    if (that.proName.length || that.serviceNum.length) {
                        this.timer = setInterval(function () {  
                            if (option.dataZoom[0].endValue == serviceNum.length ) {
                                option.dataZoom[0].endValue = 2; 
                                option.dataZoom[0].startValue = 0;
                            }
                            else {
                                option.dataZoom[0].endValue = option.dataZoom[0].endValue + 1;
                                option.dataZoom[0].startValue = option.dataZoom[0].startValue + 1;
                            } 
                            myChart.setOption(option, true); 
                        }, 2000);
                        option = { 
                            animation:false,
                            grid: {
                                top: '10%',
                                left: '5%',
                                bottom: "5%",
                                right: "5%",
                                containLabel: true
                            }, 
                            xAxis: {
                                type: 'category',
                                splitLine: {
                                    show: false, 
                                }, 
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: '#00DAEE', 
                                        width:3
                                    },
                                    fontSize: fitChartSize(12),
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLabel: {
                                    fontSize: fitChartSize(12),
                                    color: '#fff'
                                },
                                data: proName, 
                            },  
                            dataZoom: [//滑动条
                                {
                                    // yAxisIndex: 0,//这里是从X轴的0刻度开始
                                    show: false,//是否显示滑动条，不影响使用
                                    type: 'slider', // 这个 dataZoom 组件是 slider 型 dataZoom 组件
                                    startValue: 0, // 从头开始。
                                    endValue: 5,  // 一次性展示 个。
                                    width: "100%"
                                }, 
                            ],
                            yAxis: [{
                                type: 'value',  
                                splitLine: {
                                    show: false,
                                },
                                axisLine: {
                                    show: false,
                                    lineStyle: {
                                        color: '#677588'
                                    },
                                    fontSize: fitChartSize(14),
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLabel: {
                                    show:false,
                                    fontSize: fitChartSize(12),
                                    interval: 0,
                                    color: '#677588'
                                }, 
                                data: serviceNum, 
                            }],
                            series: [ 
                                { 
                                    type: 'bar',
                                    // label: {
                                    //     normal: {
                                    //         position: 'right',
                                    //         show: true,
                                    //         textStyle: {
                                    //             color: '#fff',
                                    //             fontSize: fitChartSize(12),
                                    //         }
                                    //     }
                                    // },
                                    itemStyle: {
                                        normal: {
                                            color:function(params){ 
                                                let colorList = ["#0DE09D", "#FB9701", "#25A6FF", "#5470C6", "#99F0FF", '#3b55a5', '#24397b'];
                                                return colorList[params.dataIndex]
                                            }
                                        }
                                    },
                                    barWidth: fitChartSize(40),
                                    data: serviceNum, 
                                }, 
                            ]
                        };
                        myChart.clear();
                        myChart.setOption(option, true);
                        window.addEventListener("resize", that.changeScreen(myChart));
                        // let index = 0; //top多少就从多少开始
                        //     console.log(option.dataZoom[0].endValue)
                        // this.timer = setInterval(function () {
                        //     var axisData = that.proName[index];
                        //     var data0 = option.series[0].data;
                        //     var data1 = option.series[1].data;
                        //     data0.shift();
                        //     data1.shift();
                        //     data0.push(that.waterNum[index]);
                        //     data1.push(that.serviceNum[index]);
                        //     option.yAxis.data.shift();
                        //     option.yAxis.data.push(axisData);
                        //     myChart.setOption(option, true);
                        //     index += 1;
                        //     if (index >= that.proName.length) {
                        //         index = 0;
                        //     } 
                        //     myChart.setOption(option, true);
                        //     window.addEventListener("resize", that.changeScreen(myChart));
                        // }, 2000);
                    } else {
                        // option = {
                        //     title: {
                        //         text: "暂无数据",
                        //         x: "center",
                        //         y: "center",
                        //         textStyle: {
                        //             color: "#ccc",
                        //             fontWeight: "normal",
                        //             fill: "#9d9d9d",
                        //             fontWeight: "bold",
                        //             text: "暂无数据",
                        //             fontFamily: "Microsoft YaHei",
                        //             fontSize: fitChartSize(18)
                        //         }
                        //     }
                        // };
                        // myChart.clear();
                        // myChart.setOption(option, true)
                        // window.addEventListener("resize", that.changeScreen(myChart));
                    }
                })
            }
            
        },
        changeScreen(myChart){
            myChart.resize();
        }
    },
    destroyed(){ 
        // this.serviceNumStatus=false;
        if(this.timer){
            clearInterval(this.timer);
            this.timer = null;
        } 
        window.removeEventListener("resize",this.changeScreen)
    }
}
</script>

<style lang="scss" scoped> 
.h-19{ 
    height: 19.3rem;  
}
.h-17{ 
    // height: 15rem;  
    height: 100%;  
} 
#ui-server{ 
    height: 100%;  
}
</style>



// WEBPACK FOOTER //
// src/components/LineBar.vue